"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendNft = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const modal_1 = require("../../../components/ui/modal");
// import { fstat } from 'fs'
const send_status_1 = require("../../../components/send-status");
const send_to_1 = require("./send-to");
const checkout_1 = require("./checkout");
const wallet_1 = require("../../../logic/wallet");
const svg_selector_1 = require("../../../assets/svg-selector");
const send_nft_module_css_1 = __importDefault(require("./send-nft.module.css"));
const getClient_1 = require("../../../utils/getClient");
const SendNft = ({ showSendModal, setShowSendModal, setShowNftDetail, setNftDetail, isTg, addressUser, transHistory, packHistory, checkAndReturnAddress, psw, walletBalanceTON, sendData, message, setSendData, addressNft }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [position, setPosition] = (0, react_1.useState)(0);
    const [isSended, setIsSended] = (0, react_1.useState)(false);
    const [isSubmited, setIsSubmited] = (0, react_1.useState)(false);
    const [sendSuccess, setSendSuccess] = (0, react_1.useState)(false);
    const TgObj = sdk_1.default;
    (0, react_1.useEffect)(() => {
        setSendData({
            ...sendData,
            addressNft
        });
    }, [addressNft]);
    // qr code state
    const [isScanned, setIsScanned] = (0, react_1.useState)(false);
    const handleCloseModal = () => {
        setShowSendModal(false);
        // setShowNftDetail(false)
        // setNftDetail(undefined)
        setPosition(0);
        window.document.body.style.overflow = 'auto';
        TgObj.MainButton.hide();
    };
    (0, react_1.useEffect)(() => {
        if (showSendModal) {
            window.document.body.style.overflow = 'hidden';
            psw.reset(true, true);
        }
        return () => {
            window.document.body.style.overflow = 'auto';
        };
    }, [showSendModal]);
    const handleBack = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (position === 0) {
            handleCloseModal();
        }
        else if (position === 1) {
            TgObj.MainButton.hide();
            setPosition(0);
        }
    };
    let switchText = '';
    switch (position) {
        case 0:
            switchText = t('send.send-to');
            break;
        case 1:
            switchText = t('send.checkout');
            break;
        case 2:
            switchText = t('send.checkout2');
            break;
        default:
            switchText = t('send.unknown');
            break;
    }
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    console.log('NFT MESSAGE', message.value);
    async function transMakeToCompl() {
        try {
            setIsSended(true);
            TgObj.MainButton.showProgress();
            const checkPsw = await wall.getPrivateKey(psw.value);
            if (typeof checkPsw === 'object') {
                // eslint-disable-next-line no-alert
                TgObj.showAlert(t('common.incorrect-password'));
                setIsSended(false);
                TgObj.MainButton.hideProgress();
                return;
            }
            const tr = await wall.signMsgNFT(sendData.addressNft, sendData.sendAddress, psw.value, message.value);
            console.log('tr', tr);
            if (!tr) {
                // eslint-disable-next-line no-alert
                TgObj.showAlert(t('common.went-wrong'));
                setSendSuccess(false);
                setPosition(2);
                setIsSended(false);
                TgObj.MainButton.hideProgress();
                TgObj.MainButton.hide();
            }
            else {
                setSendSuccess(true);
                setPosition(2);
                setIsSended(false);
                TgObj.MainButton.hideProgress();
                TgObj.MainButton.hide();
            }
        }
        catch (error) {
            const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
            const tr2 = await wall2.signMsgNFT(sendData.addressNft, sendData.sendAddress, psw.value, message.value);
            console.log('tr', tr2);
            if (!tr2) {
                // eslint-disable-next-line no-alert
                TgObj.showAlert(t('common.went-wrong'));
                setSendSuccess(false);
                setPosition(2);
                setIsSended(false);
                TgObj.MainButton.hideProgress();
                TgObj.MainButton.hide();
            }
            else {
                setSendSuccess(true);
                setPosition(2);
                setIsSended(false);
                TgObj.MainButton.hideProgress();
                TgObj.MainButton.hide();
            }
            console.error(error);
            // setPosition(2)
            // setSendSuccess(false)
            // TgObj.MainButton.hideProgress()
            // TgObj.MainButton.hide()
            // setIsSended(false)
            // console.error(error)
        }
        finally {
            setIsSended(false);
        }
    }
    console.log('sendData', sendData);
    return ((0, jsx_runtime_1.jsx)("div", { className: send_nft_module_css_1.default.wrapper, children: (0, jsx_runtime_1.jsxs)(modal_1.Modal, { isOpen: showSendModal, isCloseButton: false, className: send_nft_module_css_1.default.modal, onClose: handleCloseModal, children: [(0, jsx_runtime_1.jsxs)("div", { className: send_nft_module_css_1.default.modalTop, children: [!sendSuccess ? ((0, jsx_runtime_1.jsxs)(de_ui_1.Button, { className: send_nft_module_css_1.default.modalTopButton, onClick: handleBack, children: [position !== 0 && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "chevron-left", isTg: isTg }), position === 0 ? t('common.close') : t('common.back')] })) : ((0, jsx_runtime_1.jsx)("div", { className: send_nft_module_css_1.default.empty })), position !== 0 && ((0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: send_nft_module_css_1.default.modalTopButton, onClick: () => {
                                handleCloseModal();
                            }, children: t('common.close') }))] }), (0, jsx_runtime_1.jsxs)("div", { className: send_nft_module_css_1.default.content, children: [position === 0 && ((0, jsx_runtime_1.jsx)(send_to_1.SendTo, { transHistory: transHistory, 
                            // qr code state
                            isScanned: isScanned, setIsScanned: setIsScanned, isTg: isTg, setPosition: setPosition, sendData: sendData, setSendData: setSendData, addressUser: addressUser, packHistory: packHistory, checkAndReturnAddress: checkAndReturnAddress })), position === 1 && ((0, jsx_runtime_1.jsx)(checkout_1.Checkout, { isSubmited: isSubmited, setIsSubmited: setIsSubmited, isSended: isSended, psw: psw, isTg: isTg, position: position, sendData: sendData, setSendData: setSendData, walletBalanceTON: walletBalanceTON, message: message, transMakeToCompl: transMakeToCompl })), position === 2 && ((0, jsx_runtime_1.jsx)(send_status_1.SendStatus, { isTg: isTg, sendSuccess: sendSuccess, setSendSuccess: setSendSuccess, isSuccess: sendSuccess, sendTo: sendData.sendAddress, addressUser: addressUser }))] })] }) }));
};
exports.SendNft = SendNft;
